import gql from 'graphql-tag'

export const GET_JOB_BY_DI_CODE_ADMIN = gql`
  query readJobByDICodeQueryAdmin($input: ReadJobsInput!) {
    readJobByDICodeQueryAdmin(input: $input) {
      jobs {
        id
        upload_date
        status
        records
        filename
        username
        di_code
        display_name
      }
    }
  }
`

export const GET_JOB_BY_DI_CODE = gql`
  query readJobByDICodeQueryExternalAdmin {
    readJobByDICodeQueryExternalAdmin {
      jobs {
        id
        upload_date
        status
        records
        filename
        username
        di_code
        display_name
      }
    }
  }
`

export const GET_DI = gql`
  query readDIQuery {
    readDIQuery {
      di_code
      institution
      di_hs_avg
      di_nh_avg
    }
  }
`

export const GET_DI_ADMIN = gql`
  query readDIQueryAdmin($input: ReadDIInput!) {
    readDIQueryAdmin(input: $input) {
      di_code
      institution
      di_hs_avg
      di_nh_avg
    }
  }
`

export const GET_STUDENT_CONTEXT = gql`
  query readStudentContext($input: ReadStudentContextInput!) {
    readStudentContext(input: $input) {
      id
      geo_2010
      geo_2020
      applicant_id
      di_code
      job_id
      term
      old_sat_math
      old_sat_cr
      old_sat_writing
      sat_math
      sat_ebrw
      act_english
      act_math
      act_science
      act_reading
      act_writing
      act_composite
      display_score
      score_source
      hs_ceeb_cd
      gender
      a_nh_svi_ptile
      a_nh_college_access
      a_nh_share_no_inter
      a_nh_crime_ptile
      a_nh_family_ptile
      a_nh_educ_ptile
      a_nh_housing_ptile
      a_nh_medfaminc_ptile
      a_nh_overrall_ptile
      a_nh_overall_decile
      rural
      bie_school
      ddv_apcapstone
      a_hs_satc_25
      a_hs_satc_50
      a_hs_satc_75
      ari_rank
      ncessch
      org_nm
      a_sr_class_size
      a_pct_taking_sat
      a_avg_coll_sat_hs
      a_avg_frl_pct
      a_hs_crime_ptile
      a_hs_college_access
      a_hs_family_ptile
      a_hs_educ_ptile
      a_hs_housing_ptile
      a_hs_medfaminc_ptile
      a_hs_overrall_ptile
      a_hs_overall_decile
      application_type
      admitted
      enrolled
      waitlist
      first_year_gpa
      sophomore_retention
      need_based_grant
      pell_recipient
      pell_eligible
      race
      entry_term
      first_generation
      adv_avgapscore
      a_pct_taking_ap
      adv_aptestavail
      adv_aptaken
      dashboard_link
      a_overall
      adv_appct
      create_date
      hsgpa
      number_of_ap_exams
      ap_average
      number_of_ib_exams
      ib_average
      st_a_nh_college_access
      st_a_nh_crime_ptile
      st_a_nh_educ_ptile
      st_a_nh_family_ptile
      st_a_nh_housing_ptile
      st_a_nh_medfaminc_ptile
      st_a_nh_overrall_ptile
      st_a_hs_crime_ptile
      st_a_hs_college_access_ptile
      st_a_hs_educ_ptile
      st_a_hs_housing_ptile
      st_a_hs_family_ptile
      st_a_hs_medfaminc_ptile
      st_a_hs_overrall_ptile
      st_a_overall
      city
      state
      country
      address1
      address2
      address3
      zip
      custom_1
      custom_2
      custom_3
      ddv_apcapstone
      po_box
      chartDisplayUnits
      frl_flag
    }
  }
`

export const GET_HISTORICAL_REPORTS_BY_DI_CODE = gql`
  query getHistoricalReportByDiCode {
    getHistoricalReportByDiCode {
      historicalReports {
        fileName
        fileKey
        di_code
        reportCreatedDate
        fileSize
      }
    }
  }
`

export const GET_HISTORICAL_REPORTS_BY_DI_CODE_ADMIN = gql`
  query getHistoricalReportByDiCodeAdmin($input: HistoricalReportReadInput!) {
    getHistoricalReportByDiCodeAdmin(input: $input) {
      historicalReports {
        fileName
        fileKey
        di_code
        reportCreatedDate
        fileSize
      }
    }
  }
`

export const GET_AGG_REPORTS_BY_DI_CODE = gql`
  query getAggReportByDiCodeExternalAdmin {
    getAggReportByDiCodeExternalAdmin {
      aggReports {
        di_code
        createDate
        fileKey
        fileName
        fileSize
        recordsCount
        aggFileID
      }
    }
  }
`

export const GET_AGG_REPORTS_BY_DI_CODE_ADMIN = gql`
  query getAggReportByDiCodeAdmin($input: ReadAggReportByDiCodeInput!) {
    getAggReportByDiCodeAdmin(input: $input) {
      aggReports {
        di_code
        createDate
        fileKey
        fileName
        fileSize
        recordsCount
        aggFileID
      }
    }
  }
`

export const GET_QC_CSV_CONTENTS = gql`
  query getQcAsCsvQueryExternalAdmin($input: QcModalDataQueryInput!) {
    getQcAsCsvQueryExternalAdmin(input: $input) {
      contents
    }
  }
`

export const GET_QC_MODAL_DATA_BY_JOB_ID = gql`
  query getQcModalDataQuery($input: QcModalDataQueryInput!) {
    getQcModalDataQuery(input: $input) {
      # generic
      id
      entry_term
      records
      # missingness
      m_geo
      m_hs_ceeb_cd
      m_gender
      m_race
      m_display_score
      m_admitted
      m_enrolled
      m_first_year_gpa
      m_sophomore_retention
      # oob
      oob_gender
      oob_race
      oob_display_score
      oob_admitted
      oob_enrolled
      oob_first_year_gpa
      oob_sophomore_retention
      # summary stats
      ss_gender_1
      ss_gender_2
      ss_gender_3
      ss_race_1
      ss_race_2
      ss_race_3
      ss_race_4
      ss_race_5
      ss_race_6
      ss_race_7
      ss_race_8
      ss_race_9
      ss_display_score
      ss_admitted_0
      ss_admitted_1
      ss_enrolled_0
      ss_enrolled_1
      ss_first_year_gpa
      ss_sophomore_retention_0
      ss_sophomore_retention_1
      # usability stats
      ss_hist_usable
      ss_yoy_usable
      ss_stage
    }
  }
`

export const GET_AP_CONTEXT_ALLOWED_SCHOOLS = gql`
  query getAPContextAllowedSchools {
    getAPContextAllowedSchools {
      institutions {
        di_code
        org_id
      }
    }
  }
`

export const GET_AP_CONTEXT_DATA = gql`
  query getApContextData($ai_code: String!) {
    getApContextData(ai_code: $ai_code) {
      highschool {
        name
        ai_cd
        state_cd
        total_students_taken_ap
        a_pct_taking_ap
        adv_aptaken
        adv_avgapscore
        adv_aptestavail
        ddv_apcapstone
        a_sr_class_size
      }
      ap_exams {
        ap_exam_name
        ap_exam_display_cohorts {
          recalibration
          parent_ed_lvl_flag_combo
          cohort_recalibration_students_cn
          cohort_recalibration_avg_score
          cohort_students_cn
          cohort_students_pct
          score_cohorts {
            max_ap_score
            recalibration_score_student_cnt
            recalibration_score_student_pct
          }
        }
      }
    }
  }
`

export const GET_ALL_QC_DATA_ADMIN = gql`
  query getAllQcDataQueryAdmin($input: QcAllDataQueryInput!) {
    getAllQcDataQueryAdmin(input: $input) {
      # generic
      id
      di_code
      entry_term
      records
      jobId
      job_id
      reportType
      hashKey
      rangeKey
      institutionName
      # missingness
      m_geo
      m_hs_ceeb_cd
      m_gender
      m_race
      m_display_score
      m_admitted
      m_enrolled
      m_first_year_gpa
      m_sophomore_retention
      # oob
      oob_gender
      oob_race
      oob_display_score
      oob_admitted
      oob_enrolled
      oob_first_year_gpa
      oob_sophomore_retention
      # summary stats
      ss_gender_1
      ss_gender_2
      ss_gender_3
      ss_race_1
      ss_race_2
      ss_race_3
      ss_race_4
      ss_race_5
      ss_race_6
      ss_race_7
      ss_race_8
      ss_race_9
      ss_display_score
      ss_admitted_0
      ss_admitted_1
      ss_enrolled_0
      ss_enrolled_1
      ss_first_year_gpa
      ss_sophomore_retention_0
      ss_sophomore_retention_1
      # usability stats
      ss_hist_usable
      ss_yoy_usable
      ss_stage
      # review statuses
      rs_reviewed
      rs_best
      rs_yoy_usable
      rs_hist_usable
      rs_notes
      rs_last_update
      rs_username
    }
  }
`

export const GET_ALL_JOBS_ADMIN = gql`
  query readAllJobsQueryAdmin {
    readAllJobsQueryAdmin {
      jobs {
        id
        status
        records
        rejected
        filename
        username
        di_code
        upload_date
        display_name
        failure_message
      }
    }
  }
`

export const GET_USER_ACTIVITY = gql`
  query readUserActivityQueryAdmin {
    readUserActivityQueryAdmin {
      users {
        username
        di_code
        last_login
      }
    }
  }
`

export const GET_INSTITUTIONS_ADMIN = gql`
  query getAllInstitutionsAdmin {
    getAllInstitutionsAdmin {
      institutions {
        di_code
        institution
        last_update
        di_hs_avg
        di_nh_avg
        last_login
      }
    }
  }
`

export const GET_ALL_INSTITUTION_PREFERENCES = gql`
  query getAllPreferencesAdmin {
    getAllPreferencesAdmin {
      preferences {
        values {
          di_code
          chartDisplayUnits
        }
      }
    }
  }
`
export const GET_INSTITUTION_PREFERENCES = gql`
  query getPreferenceByDiCode {
    getPreferenceByDiCode {
      values {
        di_code
        chartDisplayUnits
      }
    }
  }
`
export const GET_APP_PREFERENCES = gql`
  query getAppPreferences {
    getAppPreferences {
      values {
        disable_job_upload
        disable_job_upload_msg
        disable_job_upload_title
        service_maintenance_mode
      }
    }
  }
`

export const GET_ADMIN_WHITELIST_ADMIN = gql`
  query getAdminWhitelistAdmin {
    getAdminWhitelistAdmin {
      usernames
    }
  }
`

export const GET_ALL_INSTITUTIONS = gql`
  query getAllInstitutionsAdmin {
    getAllInstitutionsAdmin {
      di_code
      institution
    }
  }
`

export const GET_ZOOM_PASSWORDS = gql`
  query getZoomPasswords {
    getZoomPasswords {
      values {
        landscape_implementation_determining_use_strategy
        determining_landscape_strategy
        landscape_uploading_decision_files
        landscape_practitioner_panel
        admission_leaders_discuss_landscape_for_scholarship_review
        landscape_epl_account_creation
        landscape_file_upload_download
        jumpstart_your_use_of_landscape
        landscape_train_the_trainers
        landscape_past_webinars
        landscape_training_july_2023
      }
    }
  }
`
